import { PluginKey } from 'prosemirror-state';

export const PLUGIN_NAME = 'heading-links';
export const PLUGIN_KEY: PluginKey = new PluginKey(PLUGIN_NAME);

export enum EDITOR_HEADING_LINKS_EXPERIMENT_COHORTS {
	NOT_ENROLLED = 'not-enrolled',
	CONTROL = 'control',
	VARIANT = 'variant',
}
